import type { Appearance } from "@/react/providers/Theme";
import { APPEARANCE } from "@/react/providers/Theme";

import type { CustomEmojiShape } from "./types";

const constructCustomEmojiIcon = (
  name: string,
  src: string,
): CustomEmojiShape => ({
  id: `icon-${name}`,
  name,
  short_names: [name],
  skins: [
    {
      src,
    },
  ],
});

const iconAssets = import.meta.glob<string>(
  "/app/assets/images/emoji-picker-v3/icons/*/*.png",
  { eager: true, import: "default" },
);

const getAssetDirectory = (path: string): string | undefined =>
  path.split("/").at(-2);

const getAssetName = (path: string): string => {
  const filename = path.split("/").at(-1) ?? "";
  return filename.replace(/^icon-/, "").replace(/\.png$/, "");
};

const getIcons = (appearance: string): CustomEmojiShape[] =>
  Object.entries(iconAssets)
    .filter(([path]) => getAssetDirectory(path) === appearance)
    .map(([path, src]) => constructCustomEmojiIcon(getAssetName(path), src));

const LightAppearanceIcons = getIcons("light");
const DarkAppearanceIcons = getIcons("dark");

export const CUSTOM_ICON_LIGHT_DATA_SET = [
  {
    id: "icons",
    name: "icons",
    emojis: LightAppearanceIcons,
  },
] as const;

export const CUSTOM_ICON_DARK_DATA_SET = [
  {
    id: "icons",
    name: "icons",
    emojis: DarkAppearanceIcons,
  },
] as const;

export const customEmojiIconUrl = (
  identifier: string,
  appearance: Appearance,
) => {
  let dataset = CUSTOM_ICON_LIGHT_DATA_SET;
  if (appearance === APPEARANCE.DARK) {
    dataset = CUSTOM_ICON_DARK_DATA_SET;
  }
  const emoji = dataset[0].emojis.find(emoji => emoji.id === identifier);

  return emoji?.skins?.[0]?.src;
};
